<template>
    <BCol cols="12" :md="vsMd" :lg="vsLg">
        <ValidationProvider #default="validationContext" :name="$t(vsName)" :rules="vsRules">
            <BFormGroup :label="$t(vsName)" :label-for="encodeURIComponent(vsName).replace('%20','_').toLowerCase()"  :class="vsRequired == '' ? 'required-field' : ''">
                <BFormInput :id="encodeURIComponent(vsName).replace('%20','_').toLowerCase()" :value="vsModel" @input="$emit('update:vsModel', $event)" type="number" :step="vsStep" :disabled="vsDisabled" />
                <BFormInvalidFeedback :state="getValidationState(validationContext)"> {{validationContext.errors[0]}} </BFormInvalidFeedback>
            </BFormGroup>
        </ValidationProvider>
    </BCol>
</template>

<script>
import { ValidationProvider } from 'vee-validate';
import { BCol, BFormGroup, BFormInput, BFormInvalidFeedback } from 'bootstrap-vue';
import formValidation from '@core/comp-functions/forms/form-validation';

export default {
    components:{ ValidationProvider, BCol, BFormGroup, BFormInput, BFormInvalidFeedback },
    props: ['vsName', 'vsModel', 'vsMd','vsLg', 'vsRules', 'vsRequired', 'vsStep', 'vsDisabled'],
    emit: ['update:vsModel'],
    setup() {
        const { getValidationState } = formValidation()

        return {
            getValidationState
        }
    },
}
</script>